import Tab from 'bootstrap/js/dist/tab';

export function initNavTabs() {
    document.querySelectorAll('.nav-tabs').forEach((nav) => {
        nav.querySelectorAll('.nav-link').forEach((tabButton) => {
        const targetSelector = tabButton.dataset.target;
        if (!targetSelector) return;

        const targetPane = document.querySelector(targetSelector);
        if (!targetPane) return;

        const tab = new Tab(tabButton);

        tabButton.addEventListener('click', (e) => {
            e.preventDefault();
            tab.show();
        });
        });
    });
}